import { createAsyncThunk } from "@reduxjs/toolkit";
import apiClient from "../../../API/apiClient ";

export const GetItemGroup = createAsyncThunk(
    'OrderPage/ItemGrp',
    async (_, { rejectWithValue }) => {
      try {        
        const response = await apiClient.get('Sales/OrderPage/GetItemGrp');
        return response.data;  // Return data to be stored
      } catch (error) {
        return rejectWithValue(error.response?.data || 'Error fetching data');
      }
    }
  );

  export const GetItemByGrp = createAsyncThunk(
    'OrderPage/ItemByGrp',
    async ({ItemSize, Delivery}, { rejectWithValue }) => {
      try {        
        const response = await apiClient.get(`Sales/OrderPage/GetItemByItmGrp?ITEMSIZE=${ItemSize}&DELIVERYTYPE=${Delivery}`);
        return response.data;  // Return data to be stored
      } catch (error) {
        return rejectWithValue(error.response?.data || 'Error fetching data');
      }
    }
  );

  
  export const GetCustomerData = createAsyncThunk(
    'OrderPage/CustomerData',
    async ({SEARCHTEXT}, { rejectWithValue }) => {
      try {        
        const response = await apiClient.get(`Sales/OrderPage/GetCustomer?SEARCHTEXT=${SEARCHTEXT}`);
        return response.data;  // Return data to be stored
      } catch (error) {
        return rejectWithValue(error.response?.data || 'Error fetching data');
      }
    }
  );
  export const GetItemBySearch = createAsyncThunk(
    'OrderPage/ItemBysearch',
    async ({searchText,page}, { rejectWithValue }) => {
      try {        
        const response = await apiClient.get(`Sales/OrderPage/GetItemBySearch?SEARCHTEXT=${searchText}&PAGENUMBER=${page}&PAGESIZE=${100}`);
        return response.data;  // Return data to be stored
      } catch (error) {
        return rejectWithValue(error.response?.data || 'Error fetching data');
      }
    }
  );
  // export const PostSalesOrder = createAsyncThunk(
  //   'OrderPage/PostSoOrder',
  //   async (dataList, { rejectWithValue }) => {
  //     try {
  //       const response = await apiClient.post(`/Sales/OrderPage/InsertSO`, dataList);
  //       return response.data;  
  //     } catch (error) {
  //       return rejectWithValue(error.response?.data);
  //     }
  //   }
  // );
  export const PotingSaleData = createAsyncThunk(
    'OrderPage/PostSQ',
    async (dataList, { rejectWithValue }) => {
      try {
        const response = await apiClient.post(`/Sales/OrderPage/PotingSaleData`, dataList);
        return response.data;  
      } catch (error) {
        return rejectWithValue(error.response?.data);
      }
    }
  );
  export const UpdateSalesQuotation = createAsyncThunk(
    'HistoryPage/UpdateSQ',
    async (dataToSend, { rejectWithValue }) => {
      try {
        const response = await apiClient.post(`Sales/OrderPage/UpdateSQ`, dataToSend);
        return response.data;  
      } catch (error) {
        return rejectWithValue(error.response?.data);
      }
    }
  );
  export const UpdateSalesOrder = createAsyncThunk(
    'HistoryPage/UpdateSO',
    async (dataList, { rejectWithValue }) => {
      try {
        const response = await apiClient.post(`Sales/OrderPage/UpdateSalesOrder`, dataList);
        return response.data;  
      } catch (error) {
        return rejectWithValue(error.response?.data);
      }
    }
  );
  export const convertQuotationToOrder = createAsyncThunk(
    'OrderHistory/convertQuotationToOrder',
    async ({ docEntry }, { rejectWithValue }) => {
      try {
        const response = await apiClient.post(
          `Sales/OrderPage/convertSalesQuotationtoorder?docEntry=${docEntry}`
        );
        return response.data;
      } catch (error) {
        return rejectWithValue(error.response?.data || 'Conversion failed');
      }
    }
  );
  export const GetAttachments = createAsyncThunk(  
    'OrderHistory/QuotationAttachments',
    async ({docEntry,DocType}, { rejectWithValue }) => {
      try {        
        const response = await apiClient.get(`SalesHistory/GetAttachment?DocEntry=${docEntry}&DocType=${DocType}`);
        return response.data;  
      } catch (error) {
        return rejectWithValue(error.response?.data || 'Error fetching data');
      }
    }
  );
  export const CancelSQAndSO = createAsyncThunk(  
    'OrderHistory/CancelSQAndSO',
    async ({docEntry,DocType}, { rejectWithValue }) => {
      try {        
        const response = await apiClient.post(`Sales/OrderPage/cancelDocument?docEntry=${docEntry}&doctype=${DocType}`);
        return response.data;  
      } catch (error) {
        return rejectWithValue(error.response?.data || 'Error fetching data');
      }
    }
  );
  export const GetdocType = createAsyncThunk(  
    'OrderHistory/docType',
    async (_, { rejectWithValue }) => {
      try {        
        const response = await apiClient.get(`/Sales/OrderPage/GetDocumentType`);
        return response.data;  
      } catch (error) {
        return rejectWithValue(error.response?.data || 'Error fetching data');
      }
    }
  );
 
 